import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=20990b1c&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20990b1c')) {
      api.createRecord('20990b1c', component.options)
    } else {
      api.reload('20990b1c', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=20990b1c&", function () {
      api.rerender('20990b1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pgI17chdc2DK/JS/offershelp.vue"
export default component.exports